"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _base = _interopRequireDefault(require("./base"));
var _excluded = ["title"],
  _excluded2 = ["title"],
  _excluded3 = ["title"],
  _excluded4 = ["title"],
  _excluded5 = ["title"],
  _excluded6 = ["title"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// zh-Hans is currently not supported in report service
var mapLocale = function mapLocale(locale) {
  return locale === 'zh-Hans' ? 'zh' : locale;
};

/**
 * `Service` The Report service
 */
var Report = /*#__PURE__*/function (_Base) {
  /**
   * Create the report service instance.
   *
   * @param sdk - the SDK instance
   */
  function Report(sdk) {
    (0, _classCallCheck2["default"])(this, Report);
    return _callSuper(this, Report, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Report, _Base);
  return (0, _createClass2["default"])(Report, [{
    key: "createFileReport",
    value: (
    /**
     * Returns the ID of the report generation request for tracking.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/6c3c34f6cb2aa-create-a-project-report
     *
     * @param projectId - is the project id
     * @param folderUrn - folder urn
     * @param options - With the shape of
     *    title: string
     *    productType, string, allowed values: ['docs','build','cost','quantity','takeoff']
     *    includeSubFolders, boolean
     *    includeCustomAttributes, boolean
     * @param config - Configurable object for overwrite request parameters. With the shape of
     *
     * @returns a promise with an object, shape of
     *    id: string, the report id
     *    status: string, the status of the report generation
     */
    function () {
      var _createFileReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, folderUrn, options, config) {
        var payload, path, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = {
                format: 'excel',
                service: 'files',
                template: 'filesLog',
                locale: mapLocale(this.Config.locale),
                title: options.title,
                options: {
                  custom: (0, _extends2["default"])({
                    productType: 'docs',
                    folderUrn: folderUrn
                  }, (0, _omit["default"])(options, 'title'))
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context.next = 4;
              return this.HttpService.reportV2.post(path, payload, config);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createFileReport(_x, _x2, _x3, _x4) {
        return _createFileReport.apply(this, arguments);
      }
      return createFileReport;
    }()
    /**
     * Create sheets log report
     * https://b360rpt-c-uw2-v2.cosv2-c-uw2.autodesk.com/#/default/createReport
     *
     * @param projectId - , the project id
     * @param options - the payload passed to reports api, shape of
     *                      filter: \{ tags: String[], setId: String, disciplines: String[] \},
     *                      searchText: String,
     *                      withAllTags: Boolean,
     *                      title: String|required
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of id: String, status: String
     */
    )
  }, {
    key: "createSheetsLogReport",
    value: (function () {
      var _createSheetsLogReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, options, config) {
        var _ref, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref = options || {}, title = _ref.title, rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
              if (title) {
                _context2.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'sheets',
                template: 'sheetsLog',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: (0, _extends2["default"])({
                    type: 'Build'
                  }, rest)
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context2.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createSheetsLogReport(_x5, _x6, _x7) {
        return _createSheetsLogReport.apply(this, arguments);
      }
      return createSheetsLogReport;
    }()
    /**
     * Create sheets registry report
     * https://b360rpt-c-uw2-v2.cosv2-c-uw2.autodesk.com/#/default/createReport
     *
     * @param projectId - , the project id
     * @param options - request body for reports api, shape of \{ title: String|required, collectionId: String, ...rest \}
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of id: String, status: String
     */
    )
  }, {
    key: "createSheetsRegistryReport",
    value: (function () {
      var _createSheetsRegistryReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, options, config) {
        var _ref2, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref2 = options || {}, title = _ref2.title, rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
              if (title) {
                _context3.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'sheets',
                template: 'sheetsRegistry',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: (0, _extends2["default"])({
                    type: 'Build'
                  }, rest)
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context3.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context3.sent;
              return _context3.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createSheetsRegistryReport(_x8, _x9, _x10) {
        return _createSheetsRegistryReport.apply(this, arguments);
      }
      return createSheetsRegistryReport;
    }()
    /**
     * Create sheets log report with collections
     * https://b360rpt-c-uw2-v2.cosv2-c-uw2.autodesk.com/#/default/createReport
     *
     * @param projectId - , the project id
     * @param options - the payload passed to reports api, shape of
     *                    \{
     *                      filter: \{ tags: String[], setId: String, disciplines: String[] \},
     *                      searchText: String,
     *                      withAllTags: Boolean,
     *                      collectionId: String,
     *                      title: String|required
     *                    \}
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of \{ id: String, status: String \}
     */
    )
  }, {
    key: "createSheetsLogWithCollections",
    value: (function () {
      var _createSheetsLogWithCollections = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, options, config) {
        var _ref3, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref3 = options || {}, title = _ref3.title, rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
              if (title) {
                _context4.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'sheets',
                template: 'sheetsLogWithCollections',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: (0, _extends2["default"])({
                    type: 'Build'
                  }, rest)
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context4.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context4.sent;
              return _context4.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createSheetsLogWithCollections(_x11, _x12, _x13) {
        return _createSheetsLogWithCollections.apply(this, arguments);
      }
      return createSheetsLogWithCollections;
    }()
    /**
     * Create sheets registry report with collections
     * https://b360rpt-c-uw2-v2.cosv2-c-uw2.autodesk.com/#/default/createReport
     *
     * @param projectId - , the project id
     * @param options - request body for reports api, shape of \{ title: String|required, ...rest \}
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of \{ id: String, status: String \}
     */
    )
  }, {
    key: "createSheetsRegistryWithCollections",
    value: (function () {
      var _createSheetsRegistryWithCollections = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, options, config) {
        var _ref4, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _ref4 = options || {}, title = _ref4.title, rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
              if (title) {
                _context5.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'sheets',
                template: 'sheetsRegistryWithCollections',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: (0, _extends2["default"])({
                    type: 'Build'
                  }, rest)
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context5.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context5.sent;
              return _context5.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createSheetsRegistryWithCollections(_x14, _x15, _x16) {
        return _createSheetsRegistryWithCollections.apply(this, arguments);
      }
      return createSheetsRegistryWithCollections;
    }()
    /**
     * Create reviews report
     * https://b360rpt-c-uw2-v2.cosv2-c-uw2.autodesk.com/#/default/createReport
     *
     * @param projectId - , the project id
     * @param options - the payload passed to reports api, shape of
     *                    \{
     *                      title: String|required,
     *                      filter: \{ status: String, workflowId: String, initiatedBy: String, nextActionBy: String, dueDate: String \},
     *                      searchText: String,
     *                      sort: String
     *                    \}
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of \{ id: String, status: String \}
     */
    )
  }, {
    key: "createReviewsReport",
    value: (function () {
      var _createReviewsReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, options, config) {
        var _ref5, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref5 = options || {}, title = _ref5.title, rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
              if (title) {
                _context6.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'reviews',
                template: 'reviewsSummary',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: rest
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context6.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context6.sent;
              return _context6.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createReviewsReport(_x17, _x18, _x19) {
        return _createReviewsReport.apply(this, arguments);
      }
      return createReviewsReport;
    }()
    /**
     * Create transmittals report
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Report-Log.yaml
     *
     * @param projectId - , the project id
     * @param options - the payload passed to reports api, shape of
     *                    \{
     *                      title: String|required,
     *                      filter: \{ sentBy: String, beginCreatedTime: String, endCreatedTime: String \},
     *                      search: String,
     *                      sort: String
     *                    \}
     * @param config -  Configurable object for overwrite request parameters
     * @returns shape of \{ id: String, status: String \}
     */
    )
  }, {
    key: "createTransmittalsReport",
    value: (function () {
      var _createTransmittalsReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, options, config) {
        var _ref6, title, rest, payload, path, res;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _ref6 = options || {}, title = _ref6.title, rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
              if (title) {
                _context7.next = 3;
                break;
              }
              throw new Error('Missing required parameter: title');
            case 3:
              payload = {
                title: title,
                format: 'excel',
                service: 'transmittals',
                template: 'transmittalsSummary',
                locale: mapLocale(this.Config.locale),
                options: {
                  custom: rest
                }
              };
              path = "/projects/".concat(projectId, "/reports");
              _context7.next = 7;
              return this.HttpService.reportV2.post(path, payload, config);
            case 7:
              res = _context7.sent;
              return _context7.abrupt("return", res.data || {});
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createTransmittalsReport(_x20, _x21, _x22) {
        return _createTransmittalsReport.apply(this, arguments);
      }
      return createTransmittalsReport;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Report';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Report;